module.exports = __webpack_public_path__ + "Roboto-Light.69f8a0617ac472f78e45.woff2";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Light.woff2
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Light.woff2
// module chunks = styles